import React, { useState, useCallback } from 'react';
import { Trans } from '@lingui/react/macro';
import { Modal, ModalHeader, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import ExternalAgreementCreateWizard from './ExternalAgreementCreateWizard';

interface CreateExternalAgreementDialogProps {
    residentialUnitId: number;
    show: boolean;
    onClose: () => void;
    onSave: () => void;
}

const CreateExternalAgreementDialog: React.FC<CreateExternalAgreementDialogProps> = ({
    show,
    onClose,
    onSave,
    residentialUnitId,
}) => {
    const [key, setKey] = useState(0);

    const onOpen = useCallback(() => {
        setKey(key + 1);
    }, [key]);

    return (
        <Modal size="xl" toggle={onClose} isOpen={show} onOpen={onOpen}>
            <ModalHeader>
                <Trans>Add external agreement</Trans>
            </ModalHeader>
            <ModalBody>
                <ExternalAgreementCreateWizard
                    key={key}
                    residentialUnitId={residentialUnitId}
                    onSaved={() => {
                        onSave();
                        onClose();
                    }}
                    onCancel={onClose}
                />
            </ModalBody>
        </Modal>
    );
};

export default CreateExternalAgreementDialog;
